import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { AppLoggerService } from './app-logger.service';

@Injectable()
export class PerformanceInterceptor implements HttpInterceptor {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private appLogger: AppLoggerService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Skip entirely when not in browser OR API logging is disabled
    if (!isPlatformBrowser(this.platformId) || !this.appLogger.isApiEnabled) {
      return next.handle(request);
    }

    const startTime = performance.now();
    let status = 'unknown';

    return next.handle(request).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            status = `${event.status}`;
          }
        },
        error: (error: HttpErrorResponse) => {
          status = `error ${error.status}`;
        }
      }),
      finalize(() => {
        // Re-check flag at response time (flag may have changed since request started)
        if (!this.appLogger.isApiEnabled) return;

        const duration = Math.round(performance.now() - startTime);
        this.appLogger.logApi(request.method, request.urlWithParams, duration, status);
      })
    );
  }
}
